import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

// baseQueryWithReauth already handles the retry-after-refresh pattern internally.
// A second retry wrapper would amplify 401 failures (1 initial + N retries) and cause
// the logout loop seen when the refresh response field names didn't match.
export const api = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['User', 'Department', 'Employee', 'Leave', 'Payroll', 'Org', 'Document', 'Notification', 'Request', 'Salary', 'ExpensePolicy', 'PettyCash', 'CashAdvance', 'ExpenseAnalytics', 'LoanType', 'Loan', 'Jobs', 'Candidates', 'Candidate', 'IncrementCycle', 'IncrementPolicy', 'IncrementRequest', 'Roles', 'Permissions', 'Settings', 'Reports', 'Training', 'Performance', 'Attendance', 'Security', 'Branch', 'Asset', 'AssetHandover', 'Benefit', 'DailyReport', 'Alerts', 'Activity', 'LeaveHandover', 'Shifts'],
    endpoints: (builder) => ({
        getHealth: builder.query<{ status: string }, void>({
            query: () => ({ url: '/health', method: 'GET' }),
        }),
    }),
});
